import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { SectionBox } from '@/components';
import {
  complianceTransferSelectors,
  showDemoDataSelectors,
} from '@/redux/selectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { complianceTransferActions } from '@/redux/actions';

import { transfersDemoData } from '../../Transfers.constants';
import styles from './Stats.module.sass';

type StatsItemType = {
  title: string;
  value: number;
  suffix?: string;
};

const Stats = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { data: complianceTransferData } = useAppSelector(
    complianceTransferSelectors.getComplianceTransferSlice,
  );
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byCompliance);

  useEffect(() => {
    if (!isShowDemoData) {
      dispatch(complianceTransferActions.fetchTransferStats());
    }
  }, [isShowDemoData]);

  const listData = useMemo((): StatsItemType[] => {
    const data = isShowDemoData ? transfersDemoData : complianceTransferData;
    const stats = data?.stats;
    return [
      {
        title: t('translation.total'),
        value: stats?.total || 0,
      },
      {
        title: t('translation.income'),
        value: stats?.income || 0,
      },
      {
        title: t('translation.outcome'),
        value: stats?.outcome || 0,
      },
    ];
  }, [complianceTransferData, isShowDemoData]);

  return (
    <SectionBox>
      {{
        body: (
          <div className={styles.stats}>
            {listData.map((item) => (
              <div key={item.title} className={styles.item}>
                <div className={styles.title}>{item.title}</div>
                <NumericFormat
                  value={item.value}
                  suffix={item.suffix ? ` ${item.suffix}` : ''}
                  displayType="text"
                  thousandSeparator=" "
                  className={styles.value}
                />
              </div>
            ))}
          </div>
        ),
      }}
    </SectionBox>
  );
};

export default Stats;
